<div id="more-filter">
  <h2 class="m-b-5" mat-dialog-title>{{popupTitle}}</h2>
  <div mat-dialog-content>
    <app-transfer-medico *ngIf="TransferType === TaskTransferTypes.Doctor" [FormElement]="selectionService.TaskTransferInput"></app-transfer-medico>
    <app-transfer-administrativas *ngIf="TransferType === TaskTransferTypes.Administrator" [FormElement]="selectionService.TaskTransferInput"></app-transfer-administrativas>
    <app-task-change-date *ngIf="TransferType === TaskTransferTypes.Date" [FormElement]="selectionService.TaskTransferInput"></app-task-change-date>
  </div>

  <div class="text-a-r  m-t-10 m-b-10">
    <button mat-raised-button color="accent" (click)="transferTasks()" class="m-r-15">Consultar</button>
    <button mat-raised-button (click)="closePopup()" color="warn">Cancelar</button>
  </div>
</div>